
import { TransactionData } from "@/types/types";
import { SplitPaymentDialog } from "./SplitPaymentDialog";
import { PaymentDialog } from "./PaymentDialog";
import { InvoicePreviewDialog } from "./InvoicePreviewDialog";
import { TransactionDetailsDialog } from "./TransactionDetailsDialog";

interface PaymentsDialogsProps {
  isPaymentDialogOpen: boolean;
  setIsPaymentDialogOpen: (open: boolean) => void;
  isSplitPaymentDialogOpen: boolean;
  setIsSplitPaymentDialogOpen: (open: boolean) => void;
  isInvoicePreviewOpen: boolean;
  setIsInvoicePreviewOpen: (open: boolean) => void;
  selectedTransaction: TransactionData | null;
  setSelectedTransaction: (transaction: TransactionData | null) => void;
  onSplitPaymentComplete: (schedule: any[]) => void;
}

export function PaymentsDialogs({
  isPaymentDialogOpen,
  setIsPaymentDialogOpen,
  isSplitPaymentDialogOpen,
  setIsSplitPaymentDialogOpen,
  isInvoicePreviewOpen,
  setIsInvoicePreviewOpen,
  selectedTransaction,
  setSelectedTransaction,
  onSplitPaymentComplete,
}: PaymentsDialogsProps) {
  return (
    <>
      <PaymentDialog 
        open={isPaymentDialogOpen} 
        onOpenChange={setIsPaymentDialogOpen} 
      />
      
      <SplitPaymentDialog
        open={isSplitPaymentDialogOpen}
        onOpenChange={setIsSplitPaymentDialogOpen}
        onComplete={onSplitPaymentComplete}
        clientName={selectedTransaction?.client}
        // L'échéancier doit être rattaché à un abonnement réel. Le repli
        // `|| 100` faisait sinon porter les échéances sur 100 DT arbitraires.
        subscriptionId={selectedTransaction?.subscriptionId}
        totalAmount={
          typeof selectedTransaction?.amount === "number"
            ? selectedTransaction.amount
            : Number(selectedTransaction?.amount ?? 0)
        }
      />
      
      {selectedTransaction && (
        <>
          <InvoicePreviewDialog 
            open={isInvoicePreviewOpen}
            onOpenChange={setIsInvoicePreviewOpen}
            transactionData={selectedTransaction}
          />
          
          {/* <TransactionDetailsDialog 
            transaction={selectedTransaction}
            open={!!selectedTransaction && !isInvoicePreviewOpen}
            onOpenChange={(open) => {
              if (!open) setSelectedTransaction(null);
            }}
          /> */}
        </>
      )}
    </>
  );
}
